// extracted by mini-css-extract-plugin
export default {"container":"PageLoader_container__2yoC3","message":"PageLoader_message__tgz5d"};